import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgColorfulTips({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FECE00" cx={11} cy={8} r={4} />
        <path
          d="M8 3.18A2.62 2.62 0 005.38 5.8a.44.44 0 10.87 0c0-.96.79-1.75 1.75-1.75a.44.44 0 100-.87zM5.82 13.52c0 .09.03.17.07.24l.67 1c.08.13.22.2.36.2h2.16c.14 0 .28-.07.36-.2l.67-1a.44.44 0 00.07-.24v-1.17H5.82v1.17zM8 1a4.78 4.78 0 00-3.61 7.96 7.8 7.8 0 011.43 2.51h1.3c0-.13-.01-.26-.05-.38a8.6 8.6 0 00-1.7-3A3.48 3.48 0 018 2.31a3.5 3.5 0 012.63 5.78 8.62 8.62 0 00-1.7 2.99 1.3 1.3 0 00-.06.39h1.31c.27-.9.98-2 1.43-2.51A4.8 4.8 0 008 1z"
          fill="#000"
        />
      </g>
    </svg>
  );
}

SvgColorfulTips.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgColorfulTips.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgColorfulTips svgRef={ref} {...props} />);
export default ForwardRef;
